import Icon from "@expo/vector-icons/MaterialCommunityIcons";
/* -----------------Globals--------------- */
import { useAppTheme } from "@hooks/useAppTheme";
import { Box, CustomChip } from "@memorang/ui";
import CustomListSubheaderContainer from "components/CustomListSubheaderContainer";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";

type Props = {
	accordions: {
		title: string;
		children: React.ReactNode;
	}[];
	showPremiumChip?: boolean;
	showFreeChip?: boolean;
	disabled?: boolean;
};

/* -----------------Component--------------- */

const AccordionListItem = ({
	title,
	children,
	showPremiumChip = false,
	showFreeChip = false,
	disabled,
}: {
	title: React.ReactNode;
	children: React.ReactNode;
	showPremiumChip?: boolean;
	showFreeChip?: boolean;
	disabled?: boolean;
}) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	return (
		<Box>
			<Box
				alignItems="center"
				justifyContent="space-between"
				flexDirection="row"
				paddingRight={16}
			>
				<CustomListSubheaderContainer enableGutters>
					{title}
				</CustomListSubheaderContainer>
				{showPremiumChip && (
					<CustomChip
						icon={() => {
							return <Icon name={"crown-outline"} size={16} />;
						}}
						style={{
							backgroundColor: theme.palette.chips.premium,
							opacity: disabled ? 0.5 : 1,
						}}
						textStyle={{
							color: theme.colors.black,
						}}
					>
						{t("premium.chip")}
					</CustomChip>
				)}
				{showFreeChip && (
					<CustomChip
						icon={() => {
							return <Icon name={"gift-outline"} size={16} />;
						}}
						style={{
							backgroundColor: theme.palette.chips.free,
							opacity: disabled ? 0.5 : 1,
						}}
						textStyle={{
							color: theme.colors.black,
						}}
					>
						{t("dashboard.diagnostics.free")}
					</CustomChip>
				)}
			</Box>
			{children}
		</Box>
	);
};
const ListAccordion = ({
	accordions,
	showPremiumChip = false,
	showFreeChip = false,
	disabled,
}: Props) => {
	return (
		<>
			{accordions.map(({ title, children }) => {
				return (
					<Fragment key={title}>
						<AccordionListItem
							title={title}
							showPremiumChip={showPremiumChip}
							showFreeChip={showFreeChip}
							disabled={disabled}
						>
							{children}
						</AccordionListItem>
						{/* {!isLast && <Divider />} */}
					</Fragment>
				);
			})}
		</>
	);
};

export default ListAccordion;
